import AIHeroSection from './components/AIHeroSection';
import SubHeroSection from './components/SubHeroSection';
import ManualSystemsSection from './components/ManualSystemsSection';
import WhatWeBuildSection from './components/WhatWeBuildSection';
import ExamplesSection from './components/ExamplesSection';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';
import Navbar from '../../components/feature/Navbar';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const aiToolsSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Custom AI Tools for Small Businesses – True Passage Ventures',
    url: `${SITE_URL}/ai-tools`,
    description: 'True Passage Ventures builds custom AI tools and automation systems for small and medium businesses. Replace manual spreadsheets and notebooks with intelligent dashboards.',
    provider: {
      '@type': 'Organization',
      name: 'True Passage Ventures',
      url: SITE_URL,
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What kind of AI tools does True Passage Ventures build?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We build custom AI tools tailored to your business operations, including attendance dashboards, inventory trackers, automated order managers, billing systems, scheduling tools, and AI performance dashboards.',
        },
      },
      {
        '@type': 'Question',
        name: 'How long does it take to build a custom AI tool?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Timelines vary by complexity, but most custom AI tools are delivered within a few weeks. Contact us for a detailed project estimate.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do I need technical knowledge to use the AI tools?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'No. Our tools are designed to be simple and intuitive for non-technical business owners and their teams.',
        },
      },
    ],
  },
];

export default function AIToolsPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Custom AI Tools for Small Businesses – True Passage Ventures"
        description="Stop managing your business in notebooks. True Passage Ventures builds custom AI automation tools for SMBs: inventory trackers, order managers, billing systems, and more."
        keywords="custom AI tools, business automation, AI for small business, workflow automation, AI dashboard, SMB AI solutions"
        canonical="/ai-tools"
        schema={aiToolsSchema}
      />
      <Navbar />
      <AIHeroSection />
      <ManualSystemsSection />
      <WhatWeBuildSection />
      <ExamplesSection />
      <Footer />
    </div>
  );
}
